import { SessionService } from '@core/auth';

/** Reports are for Administrator and Super-Administrator, like the backend routes (#5248). */
export function canUseReports(
  session: Pick<SessionService, 'isAdministrator' | 'isSuperAdministrator'>,
): boolean {
  return !!(session.isAdministrator || session.isSuperAdministrator);
}
